import $ from 'jquery'

// let active_coll;


let coll_parent;
let current_coll;
let current_coll_parrent_state;

function changeCollapsible() {
    //console.log('change');
    // coll_parent = $(current_coll).parent();

    //console.log(current_coll_parrent_state);

    if (current_coll_parrent_state) {
        coll_parent.removeClass("collapsed");

        var content = current_coll.nextElementSibling;
        content.style.maxHeight = (content.scrollHeight + 50) + "px";
    } else {
        coll_parent.addClass("collapsed");
    }


}

function actionCollapsible(elem) {

    current_coll = elem;
    coll_parent = $(elem).parent();

    if ($(coll_parent).hasClass("collapsed")) {
        current_coll_parrent_state = true;
    } else {
        current_coll_parrent_state = false;
    }


    if (coll_parent.hasClass('collapse-others')) {
        const coll_grand_grand_parent = $(coll_parent).parent().parent();
        const ggClass = coll_grand_grand_parent.attr('class');
        const className = '.' + ggClass.split(' ')[1];
        const collapsiblesClass = className + " .collapsible";
        $(collapsiblesClass).addClass('collapsed');
    }


    setTimeout(function () {

        changeCollapsible();


    }, 2)




}

function initCollapsible() {
    $(window).on('load', function () {




        var coll = document.getElementsByClassName("collapsible");
        var i;

        for (i = 0; i < coll.length; i++) {
            let coll_button = coll[i].getElementsByClassName("collapsible--button");




            $(coll_button).click(function () {

                actionCollapsible(this);


            });

        }


        setTimeout(function () {


            if ($("body").hasClass("device-desktop")) {


                $('.grid-item.calendar[data-order="1"] .collapsible--button').click();



            }
        }, 1000);



    })
}


export default initCollapsible

